import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { WidgetsService } from '../../widgets.service';
import { AppService } from '../../../../app.service';
import { NotificationsService } from 'angular2-notifications';
import { Subscription } from 'rxjs/Subscription';
import { SearchItem } from '../../../../entities';
import { EvalCode, ComponentsFleetConditionEvalsViewModel, EvalOverViewViewModel } from '../../widgets.model';
import { WidgetsEnlargedComponentComponent } from '../widgets-enlarged-component/widgets-enlarged-component.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'components-on-eval-widget',
  templateUrl: './components-on-eval-widget.component.html',
  styleUrls: ['./components-on-eval-widget.component.scss']
})
export class ComponentsOnEvalWidgetComponent implements OnInit, OnDestroy {
  @Input() chartid: string;
  @Input() passedDataSource : any;
  @Input() isInPopup: boolean = false;
  dataSource: any;
  width: number = 280;
  height: number = 180;
  type = 'stackedcolumn2d';
  dataFormat = 'json';
  subscriptions: Subscription[] = [];
  //widgetTriggerSubscription: Subscription;
  emptySearchSelectionQuery: SearchItem[] = [{ Id: 8, SearchId: 1, SearchStr: "", Title: "Evaluation A" }, { Id: 9, SearchId: 1, SearchStr: "", Title: "Evaluation B" }, { Id: 10, SearchId: 1, SearchStr: "", Title: "Evaluation C" }, { Id: 11, SearchId: 1, SearchStr: "", Title: "Evaluation X" }];
  loading: boolean = true;
  noData: boolean = false;
  enableTab:boolean=false


  constructor(private _widgets: WidgetsService,
    private _app: AppService,
    private _notification: NotificationsService,
    private _dialog: MatDialog) {
    this.dataSource = {
      "chart": {
        "showsum": "0",
        "theme": "fusion ",
        "showLabels": "1",
        "columnHoverAlpha": "80",
        "canvasBaseDepth": "5",
        "showBorder": "0",
        "showYAxisLine": "0",
        "showXAxisLine": "0",
        "canvasBorderAlpha": "5",
        "showLimits": "0",
        "xAxisLineThickness": "0",
        "bgColor": "#ffffff",
        "yAxisValuesPadding": "8",
        // "scrollColor": "#cccccc",
        // "scrollheight": "10",
        "showValues": "0",
        "slantLabels": "0",
        "plotSpacePercent": "20",
        "paletteColors": "#6FCF97,#F2C94C,#F2994A,#EB5757,#4F4F4F",

        "maxColWidth": "20"
      },


      "categories": [
        {
          "category": [
            {
              "label": "Link"
            },
            {
              "label": "Bus"
            },
            {
              "label": "Sho"
            },
            {
              "label": "Spr"
            },
            {
              "label": "Idler"
            },
            {
              "label": "T/R"
            },
            {
              "label": "C/R"
            },
            {
              "label": "T/E"
            },
            {
              "label": "Grd"
            }
          ]
        }
      ],
      "dataset": [
        {
          "seriesname": "A",
          "data": [
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
          ]
        },
        {
          "seriesname": "B",
          "data": [

            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
          ]
        },
        {
          "seriesname": "C",
          "data": [

            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
          ]
        },
        {
          "seriesname": "X",
          "data": [

            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
          ]
        },
        {
          "seriesname": "U",
          "data": [

            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
            {
              "value": "0"
            },
          ]
        }
      ]

    }




  }

  private dataSourceToPass : ComponentsFleetConditionEvalsViewModel[];

  openWithANewPopup() {
   

    let dialogRef = this._dialog.open(WidgetsEnlargedComponentComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        chartId: this.chartid,
        dataSource: this.dataSourceToPass,
        chartTitle: "Fleet Condition",     
      }
    });

    dialogRef.afterClosed().subscribe(r => {

    });

  }

  ngOnInit() {
    this.enableTab=this._app.getEnableSearch()
      if(this.passedDataSource != null ){
        console.log("received   ", this.passedDataSource);
        this.subscriptions.push(    
           this.passedDataSource.forEach(c=>this.pushResult(c))
        );        
        this.loading = false;
        if(this.isInPopup){
          this.width = 460;
          this.height = 360;
        }
      }
      else{
        this.loadWidget(this._app.getLastSelectionSearchItems());
      }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      if (s != undefined &&!s.closed )
        s.unsubscribe();
    });
    //this.widgetTriggerSubscription.unsubscribe();
  }


  loadWidget(searchSelection: SearchItem[]) {
    this.loading = true;
    this.subscriptions.push(this._widgets.getFleetConditionOverviewOnCompart(searchSelection).subscribe(result => {
      this.dataSourceToPass = result;
      result.forEach(c =>
        this.pushResult(c),
      )

      this.loading = false;
    }, error => {
      this._notification.error('Error', 'Failed to load fleet condition. '); console.log(error);
    }));
  }
  // ComponentType

  pushResult(c: ComponentsFleetConditionEvalsViewModel) {
    //  c.EvalsAndCount.forEach(e => this.insertData( GraphMapper[c.CompartName], EvalMapper[e.Eval], ));
    switch (c.CompartName) {
      case "Link":
        this.dataSource.dataset[0].data[0] = { "value": c.EvalA };
        this.dataSource.dataset[1].data[0] = { "value": c.EvalB };
        this.dataSource.dataset[2].data[0] = { "value": c.EvalC };
        this.dataSource.dataset[3].data[0] = { "value": c.EvalX };
        this.dataSource.dataset[4].data[0] = { "value": c.EvalU };
        break;
      case "Bushing":
        this.dataSource.dataset[0].data[1] = { "value": c.EvalA };
        this.dataSource.dataset[1].data[1] = { "value": c.EvalB };
        this.dataSource.dataset[2].data[1] = { "value": c.EvalC };
        this.dataSource.dataset[3].data[1] = { "value": c.EvalX };
        this.dataSource.dataset[4].data[1] = { "value": c.EvalU };
        break;
      case "Shoe":
        this.dataSource.dataset[0].data[2] = { "value": c.EvalA };
        this.dataSource.dataset[1].data[2] = { "value": c.EvalB };
        this.dataSource.dataset[2].data[2] = { "value": c.EvalC };
        this.dataSource.dataset[3].data[2] = { "value": c.EvalX };
        this.dataSource.dataset[4].data[2] = { "value": c.EvalU };
        break;
      case "Sprocket":
        this.dataSource.dataset[0].data[3] = { "value": c.EvalA };
        this.dataSource.dataset[1].data[3] = { "value": c.EvalB };
        this.dataSource.dataset[2].data[3] = { "value": c.EvalC };
        this.dataSource.dataset[3].data[3] = { "value": c.EvalX };
        this.dataSource.dataset[4].data[3] = { "value": c.EvalU };
        break;
      case "Idler":
        this.dataSource.dataset[0].data[4] = { "value": c.EvalA };
        this.dataSource.dataset[1].data[4] = { "value": c.EvalB };
        this.dataSource.dataset[2].data[4] = { "value": c.EvalC };
        this.dataSource.dataset[3].data[4] = { "value": c.EvalX };
        this.dataSource.dataset[4].data[4] = { "value": c.EvalU };
        break;
      case "Track Roller":
        this.dataSource.dataset[0].data[5] = { "value": c.EvalA };
        this.dataSource.dataset[1].data[5] = { "value": c.EvalB };
        this.dataSource.dataset[2].data[5] = { "value": c.EvalC };
        this.dataSource.dataset[3].data[5] = { "value": c.EvalX };
        this.dataSource.dataset[4].data[5] = { "value": c.EvalU };
        break;
      case "Carrier Roller":
        this.dataSource.dataset[0].data[6] = { "value": c.EvalA };
        this.dataSource.dataset[1].data[6] = { "value": c.EvalB };
        this.dataSource.dataset[2].data[6] = { "value": c.EvalC };
        this.dataSource.dataset[3].data[6] = { "value": c.EvalX };
        this.dataSource.dataset[4].data[6] = { "value": c.EvalU };
        break;
      case "Track Elongation":
        this.dataSource.dataset[0].data[7] = { "value": c.EvalA };
        this.dataSource.dataset[1].data[7] = { "value": c.EvalB };
        this.dataSource.dataset[2].data[7] = { "value": c.EvalC };
        this.dataSource.dataset[3].data[7] = { "value": c.EvalX };
        this.dataSource.dataset[4].data[7] = { "value": c.EvalU };
        break;
      case "Guard":
        this.dataSource.dataset[0].data[8] = { "value": c.EvalA };
        this.dataSource.dataset[1].data[8] = { "value": c.EvalB };
        this.dataSource.dataset[2].data[8] = { "value": c.EvalC };
        this.dataSource.dataset[3].data[8] = { "value": c.EvalX };
        this.dataSource.dataset[4].data[8] = { "value": c.EvalU };
        break;
      default: break;
    }
  }


}
export enum GraphMapper {
  Link = "Link",
  Bushes = "Bushing",
  Shoes = "Shoe",
  Sprocket = "Sprocket",
  Idler = "Idler",
  TrackRoller = "Track Roller",
  CarrierRoller = "Carrier Roller",
  TrackElongation = "Track Elongation",
  Guard = "Guard"
}


export enum NewEvalValesMapper {
  EvalA = 0,
  EvalB = 1,
  EvalC = 2,
  EvalX = 3,
  EvalU = 4,
}
